import React, { FC, useEffect } from 'react';
import { useGetDocumentTemplates } from 'src/api/queries/useGetDocumentTemplates';
import {
  TemplateType,
  DocumentTemplateConfig,
  DEFAULT_DOCUMENT_TEMPLATES,
} from 'src/api/services/packagesService';
import './DocumentTemplateView.scss';

export type { TemplateType };

interface DocumentTemplateViewProps {
  type: TemplateType;
  onBack: () => void;
}

export const DocumentTemplateView: FC<DocumentTemplateViewProps> = ({ type, onBack }) => {
  const { data: templatesMap, isLoading } = useGetDocumentTemplates();

  const config: DocumentTemplateConfig =
    templatesMap?.[type] ||
    DEFAULT_DOCUMENT_TEMPLATES[type] ||
    DEFAULT_DOCUMENT_TEMPLATES.contractual_terms;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
    const dashboardMain = document.querySelector('.dashboard-main');
    if (dashboardMain) {
      dashboardMain.scrollTop = 0;
    }
    const packagesContainer = document.querySelector('.packages-container');
    if (packagesContainer) {
      packagesContainer.scrollTop = 0;
    }
  }, [type]);

  return (
    <div className="document-template-view">
      {/* Header */}
      <div className="template-header">
        <button type="button" className="btn-template-back" onClick={onBack}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
          >
            <polyline points="15 18 9 12 15 6" />
          </svg>
          <h1 className="template-main-title">{config.title}</h1>
        </button>
        <p className="template-subtitle">{config.subtitle}</p>
      </div>

      {/* Main Content Card */}
      <div className="template-content-card">
        {isLoading && !templatesMap ? (
          <div
            className="template-loading-state"
            style={{ padding: '40px', textAlign: 'center', color: '#94a3b8' }}
          >
            <span>{'Loading terms...'}</span>
          </div>
        ) : (
          <div className="clauses-list">
            {config.clauses.map((clause) => (
              <div key={clause.number} className="clause-item">
                <h3 className="clause-title">
                  {clause.number}. {clause.title}
                </h3>
                <p className="clause-text">{clause.content}</p>
              </div>
            ))}
          </div>
        )}

        {/* Card Footer */}
        <div className="template-card-footer">
          <div className="footer-meta-row">
            <span className="meta-label">{'Last updated'}</span>
            <span className="meta-value">{config.lastUpdated}</span>
          </div>
          <div className="footer-meta-row">
            <span className="meta-label">{'Version'}</span>
            <span className="meta-value">{config.version}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
